import React from 'react'
import { useStatusSectionData } from '../hooks'
import { EntityDetail } from '@user/store/map/typings'
import { ENTITY_TYPES, LocationDTO } from '@sales-center/common'
import Paper from '@mui/material/Paper/Paper'
import Typography from '@mui/material/Typography'
import { useD2DKnockEnabled } from '@user/store/tenantFeatures/hooks/useD2DKnockEnabled'
import { StatusChip } from '@user/features/MapView/StatusChip'
import { KnockStatusChip } from '@user/features/MapView/KnockStatusChip'
import { NextActionDate } from '@user/components/EntityCards/atoms/NextActionDate/NextActionDate'

type Props = {
  entityDetails: EntityDetail | null
  variant: string
  canUpdate?: boolean
  serviceLocation: LocationDTO
}

export function StatusSection(props: Props) {
  const { entityDetails, variant, canUpdate, serviceLocation } = props
  const isD2dEnabled = useD2DKnockEnabled()

  const { status, entityTypeDisplay, id, nextActionDate, knockStatus } =
    useStatusSectionData({
      entityDetails,
      variant,
      serviceLocation,
    })
  return (
    <Paper
      variant="outlined"
      sx={{
        mt: 1.6,
        px: 1.2,
        pt: 1.2,
        pb: 0.7,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {entityTypeDisplay !== 'Pending Lead' && (
        <NextActionDate
          id={id}
          nextActionDate={nextActionDate ? new Date(nextActionDate) : null}
          entity={
            variant.toLowerCase() === 'lead'
              ? ENTITY_TYPES.Lead
              : ENTITY_TYPES.Opportunity
          }
          disabled={!canUpdate}
          updateEntityDetails
          containerStyles={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
            justifyContent: 'space-between',
          }}
        />
      )}
      <Typography mb={0.8} maxHeight={'24px'} variant="subtitle1">
        {entityTypeDisplay}
      </Typography>
      {status && (
        <Typography variant="subtitle4" sx={{ display: 'flex', gap: 0.8 }}>
          Status: <StatusChip status={status} />
        </Typography>
      )}
      {isD2dEnabled && (
        <Typography
          variant="subtitle4"
          sx={{ display: 'flex', gap: 0.8, mt: 0.8 }}
        >
          Knock Status:{' '}
          <KnockStatusChip
            status={
              knockStatus && !!knockStatus.status ? knockStatus.status : 'None'
            }
            isDefault={
              knockStatus && !!knockStatus.status
                ? knockStatus.isDefault
                : false
            }
          />
        </Typography>
      )}
      {isD2dEnabled && (
        <Typography
          variant="body2"
          sx={{
            mt: 0.8,
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
          }}
        >
          <Typography component="span" variant="subtitle4">
            Knock status reason:
          </Typography>
          {'  '}
          {knockStatus && !!knockStatus.note ? knockStatus.note : '-'}
        </Typography>
      )}
    </Paper>
  )
}
